import { defineStore } from 'pinia';
import { useAPI } from '~/composables/useAPI';

export const useContactosStore = defineStore('contactos', {
    state: () => ({

    }),
    actions: {
        async sendContacto(payload) {
            const api = useAPI();
            const response = await api.post('contactsinfo', payload);
            //this.destacados = response.data;
        },

    },
});
